export enum SubscriptionStatus {
  TRIALING = 'trialing',
  ACTIVE = 'active',
  EXPIRING = 'expiring',
  CANCELED = 'cancelled',
  SUSPENDED = 'suspended'
}
